/**
 * External dependencies
 */
import { Provider } from 'react-redux';

/**
 * Internal dependencies
 */
import createAppStore from '@naruto/bgdcms/src/providers/initializeStore';
import createAppModel from '@naruto/bgdcms/src/providers/initializeModel';
import createMiddleware from '@naruto/bgdcms/src/providers/initializeMiddleware';
import { ProviderProps, ReducerProvider } from './types';

export default function createProvider(config: ProviderProps): ReducerProvider {
  const initialMiddleWare = createMiddleware(config.middlewareConfig);
  const initialModel = createAppModel();
  const initialStore = createAppStore({ initialModel, initialMiddleWare });

  return { Provider, initialStore };
}
